import { Box } from "@mui/material"
import { useNavigate } from "@tanstack/react-router"
import type { ColumnSort, OnChangeFn, Row, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, Ref } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { Product } from "@/graphql/codegen/graphql"
import { useProductListColumns } from "@/screens/Products/hooks/useProductListColumns"

interface ProductListTableProps {
  data: Product[]
  fetching: boolean
  scrollHandler: () => void
  tableContainerRef?: Ref<HTMLDivElement>
  handleSortingChange: (updaterFn: (state: SortingState) => SortingState) => void
  onToggleProductStatus: () => void
  sorting: ColumnSort[]
  error?: Error
}
const ProductListTable: FC<ProductListTableProps> = ({
  data,
  error,
  scrollHandler,
  handleSortingChange,
  onToggleProductStatus,
  sorting,
  tableContainerRef,
  fetching,
}) => {
  const columns = useProductListColumns({
    onToggleProductStatus,
  })
  const navigate = useNavigate()

  const handleRowClick = (row: Row<Product>) => {
    navigate({ to: `/app/product/${row.original.productId}/edit/information` })
  }

  return (
    <Box className='flex h-full flex-col'>
      <AerosBaseTable
        error={error}
        features={{
          table: {
            stickyHeader: true,
          },
          tanstackOptions: {
            data,
            columns,
            state: {
              sorting,
              isLoading: fetching,
            },
            manualSorting: true,
            enableSorting: true,
            enableMultiSort: false,
            enableSortingRemoval: false,
            getCoreRowModel: getCoreRowModel(),
            onSortingChange: handleSortingChange as OnChangeFn<SortingState>,
          },
        }}
        slotProps={{
          container: {
            ref: tableContainerRef,
            onScroll: scrollHandler,
          },
          bodyRow: {
            onClick: (row) => {
              if ("original" in row) {
                handleRowClick(row)
              }
            },
            className: "hover:bg-primary-100 cursor-pointer",
          },
        }}
        noDataMessage='No products found'
      />
    </Box>
  )
}

export default ProductListTable
